/**
 * API client for the companion's local HTTP endpoints.
 *
 * The companion runs an HTTP server on 127.0.0.1 (port from companion
 * store). These endpoints are called directly by the browser — no
 * Django round-trip needed.
 */

export interface DirectoryCheckResult {
  status: "ok" | "blocked";
  /** macOS TCC category name, e.g. "Documents Folder". */
  category?: string;
}

export interface DirectoryCheckResponse {
  results: Record<string, DirectoryCheckResult>;
  platform: string;
}

/**
 * Check whether the companion can access the given directories.
 * Returns per-directory status with optional TCC category hint.
 */
export async function checkDirectoryAccess(
  port: number,
  directories: string[],
): Promise<DirectoryCheckResponse> {
  const res = await fetch(`http://localhost:${port}/check-directories`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ directories }),
  });
  if (!res.ok) {
    throw new Error(`Directory check failed: ${res.status}`);
  }
  return res.json();
}

/**
 * Open OS privacy settings for file access on the companion's machine.
 * On macOS, opens System Settings > Privacy & Security > Files and Folders.
 */
export async function openAccessSettings(port: number): Promise<void> {
  const response = await fetch(`http://localhost:${port}/open-settings`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error("Could not open access settings");
}
